import { Auth } from 'aws-amplify'

// TODO: migrar a tipos de @aws-amplify/auth cuando actualicemos Amplify v6+.
// Estos tipos están definidos a mano y no se sincronizan con cambios upstream.
interface CognitoAccessTokenPayload {
  'cognito:groups'?: string[]
  [key: string]: unknown
}

interface CognitoSignInUser {
  signInUserSession?: {
    accessToken?: {
      payload?: CognitoAccessTokenPayload
    }
  }
}

export async function fetchCognitoGroups(): Promise<string[]> {
  try {
    const session = await Auth.currentSession()
    const payload = session.getAccessToken().payload as CognitoAccessTokenPayload
    return Array.isArray(payload['cognito:groups']) ? payload['cognito:groups'] : []
  } catch {
    return []
  }
}

export function extractGroupsFromCognitoUser(user: CognitoSignInUser): string[] {
  const groups = user?.signInUserSession?.accessToken?.payload?.['cognito:groups']
  return Array.isArray(groups) ? groups : []
}
